<template>
    <div class="ak-panel ak-panel--no-padding m-b-xs-20">
        <div class="ak-panel__header ak-panel__header--small">
            <div class="ak-panel__title">
                <i class="fa fa-check"></i>
                {{ $t('Goed te keuren aanbiedingen') }}
            </div>
        </div>
        <div class="ak-panel__body ak-panel__body--small reading">
            <div class="ak-data-table__table table-candidates">
                <table v-if="candidateOffers.length" class="ak-table ak-table--compact ak-panel__table">
                    <thead>
                        <tr class="ak-table-row ak-table">
                            <th class="ak-table-head table-head th-sticky">
                                <span>{{ $t('Datum') }}</span>
                            </th>
                            <th class="ak-table-head th-sticky">
                                <span>{{ $t('Leverancier') }}</span>
                            </th>
                            <th class="ak-table-head th-sticky">
                                <span>{{ $t('Product') }}</span>
                            </th>
                        </tr>
                    </thead>
                    <tbody  class=" ak-table-body">
                        <tr v-for="(request, index) in candidateOffers" :key="index" class="ak-table-row">
                            <td  class="ak-table-column">
                                <span>{{ request.dateCreated | date }}</span>
                            </td>
                            <td class="ak-table-column">
                                    <span v-if="request.supplier">{{ request.supplier.titlePublic }}</span>
                                <span v-else>{{ $t('Supplier Not Available') }}</span>
                            </td>
                            <td  class="ak-table-column">
                                <router-link :to="{ name: 'form', params: { bundle: 'product-approve' , definition: 'form' ,objectId:request.hashId, gridDefinition:'grid'}}" class="text-decoration-none">
                                <span>{{ request.title}}</span>
                                </router-link>
                            </td>
                        </tr>
                    </tbody>
                </table>
                <div v-else>
                    {{ $t('Geen goed te keuren aanbiedingen') }}
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'CandidateOffers',
    data() {
        return {
            loading: false,
            candidateOffers: null,
        }
    },
    methods: {
        async getAttests() {
            this.loading = true;
            const result = await this.$get(this.$getSetting('paths.baseCms') + '/candidatesoffers');
            if (result) {
                this.candidateOffers = result.candidateoffers;
            }

            this.loading = false;
        },
    },
    created() {
        this.getAttests();
    }
}
</script>
